import { loadStripe } from '@stripe/stripe-js'
import Env from '@/infra/env'
import { memoize } from '@/utils/memoize-util'

// This file is for lazy-loading Stripe. Importing ANYTHING from the Stripe
// library makes it start running a bunch of scripts, which we're trying
// to defer.

const memoizedStripe = memoize(() => {
  const key = Env.STRIPE_PK
  if (!key) {
    throw new Error(
      'There is a missing Billing configuration. Please contact an administrator.',
    )
  }
  const stripe = loadStripe(key)
  return stripe
})

/**
 * Gets the shared Stripe instance.
 */
export function getStripe() {
  return memoizedStripe()
}
